<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa ou Renavam"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label>Órgão consultado</label>
          <Select2 :options="filterConsultedAuthority" v-model="query.consultedAuthority"/>
        </div>

        <div class="col-md-3">
          <label>Tipo</label>
          <Select2 :options="filterKind" v-model="query.kind"/>
        </div>

        <div class="col-md-3">
          <label>Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>
      </div>
      
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
            <option value="expired_at">Data de vencimento</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>
    
    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>ID</th>
              <th>Conta</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>CNPJ</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Valor</th>
              <th>Valor a pagar </th>
              <th>Órgão consultado</th>
              <th>Vencimento</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fee in fees" :key="fee.id">
              <td>{{ fee.id }}</td>
              <td>{{ getAccountName(fee) }}</td>
              <td>{{ fee.plate }}</td>
              <td>{{ fee.renavam }}</td>
              <td>{{ fee.cnpj | cnpj }}</td>
              <td>{{ fee.kind }}</td>
              <td>{{ fee.status | t }}</td>
              <td>{{ fee.valueCents | centsToPrice }}</td>
              <td>{{ fee.finalValueCents | centsToPrice }}</td>
              <td>{{ fee.consultedAuthority | consultedAuthority }}</td>
              <td>{{ fee.expiredAt | date }}</td>
              <td>{{ fee.createdAt | datetime }}</td>
              <td>{{ fee.updatedAt | datetime }}</td>
              <td>
                <router-link :to="`/admin/maestro/fees/${fee.id}`" class="btn btn-outline">
                  Ver
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
    
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'

  import { IssuingAuthority } from '@/models/IssuingAuthority'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  export default {
    components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2 },
    computed: {
      badgeFilters() {
        return [
          this.filterAccount,
          this.filterEndDate,
          this.filterStatus,
          this.filterStartDate,
          this.filterConsultedAuthority,
          this.filterKind
        ]
      },
      fees() {
        return this.getModels || []
      },
    },
    created() {
      this.addOrderBy('updatedAt')
      this.$set(this.query, 'periodType', 'updated_at')
      
      const date = new Date()
      date.setHours(0, 0, 0)
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    },
    data: () => ({
      accounts: [],
      filterAccount: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status',
        table: [
          ['vencido', 'expired'],
          ['pago', 'paid'],
          ['em aberto', 'opened'],
          ['sem informação', 'undefined']
        ]
      }),
      filterConsultedAuthority: new Filter({
        key: 'consultedAuthority',
        label: 'Órgão consultado',
        table: IssuingAuthority.table()
      }),
      filterKind: new Filter({
        key: 'kind',
        label: 'Tipo',
        table: ['ipva', 'licenciamento']
      }),
      nameModel: 'Fee',
      showModal: false,
    }),
    filters: {
      consultedAuthority(code) {
        return IssuingAuthority.label(code)
      },
    },
    inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
    methods: {
      buildPath() {
        return 'admin/maestro/fees'
      },
      find() {
        this.asyncTemplateSelect()
      },
    },
    mixins: [ModelMapper],
    name: 'Index',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      }
    }
  }
</script>

<style scoped>
  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>